import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { gsap } from "gsap";
// import Lenis from "lenis"; // Desativado — ver bloco em animations()

export function animations() {
  // Verifica se GSAP está disponível
  if (!gsap) {
    console.warn("GSAP não está disponível");
    return;
  }

  // ===== LENIS (smooth scroll) DESATIVADO =====
  // O Lenis interceptava wheel/touch globalmente e quebrava o scroll por
  // toque dentro de modais no mobile (ex.: #modalAddAddress no checkout).
  // Como nada essencial dependia dele (sem scrollerProxy/scrollTo), o site
  // passa a usar o scroll NATIVO. Todo o código de compensação espalhado
  // (pauseSmoothScroll/resumeSmoothScroll, wheelMultiplier=0, etc.) tem
  // guarda `if (window.lenis)`, então vira no-op automaticamente com
  // window.lenis === undefined. Para reativar, basta descomentar o bloco.
  //
  // try {
  //   const lenis = new Lenis();
  //   if (typeof window !== "undefined") {
  //     window.lenis = lenis;
  //   }
  //   lenis.on("scroll", ScrollTrigger.update);
  //   gsap.ticker.add((time) => {
  //     lenis.raf(time * 1000);
  //   });
  //   gsap.ticker.lagSmoothing(0);
  // } catch (error) {
  //   console.warn("Erro ao inicializar Lenis:", error);
  // }

  // Mantém o ScrollTrigger sincronizado com o scroll nativo (sem Lenis).
  ScrollTrigger.refresh();

  initCartDrawer();
  initMenuDrawer();
  initHeaderSearch();
  initTitleAccountAnimation();
}

export function disableScroll() {
  document.body.style.overflow = "hidden";
  if (window.lenis) {
    window.lenis.stop();
  }
}

export function enableScroll() {
  document.body.style.overflow = "";
  if (window.lenis) {
    window.lenis.start();
  }
}

function initCartDrawer() {
  const cartDrawer = document.getElementById("cart-drawer");
  const cartDrawerItems = document.getElementById("cart-drawer-items");
  const backdrop = document.getElementById("backdrop");
  const btnOpenCart = document.getElementById("btnOpenCartDrawer");
  const btnCloseCart = document.getElementById("btnCloseCartDrawer");

  if (!cartDrawer || !cartDrawerItems || !backdrop || !btnOpenCart) return;

  let isOpen = false;
  window.cartDrawerIsOpen = false;

  const animateCartItems = (direction) => {
    if (!cartDrawerItems) return;
    const items = cartDrawerItems.querySelectorAll(".cart-drawer-item");
    if (!items || items.length === 0) return;
    
    const duration = 0.5;
    const stagger = 0.08;

    if (direction === "in") {
      items.forEach((item, index) => {
        if (item && gsap) {
          gsap.fromTo(
            item,
            { opacity: 0, x: 20 },
            {
              opacity: 1,
              x: 0,
              duration: duration,
              ease: "power1.out",
              delay: index * stagger,
            }
          );
        }
      });
    } else {
      items.forEach((item, index) => {
        if (item && gsap) {
          gsap.to(item, {
            opacity: 0,
            x: 20,
            duration: duration,
            ease: "power1.in",
            delay: (items.length - 1 - index) * stagger,
          });
        }
      });
    }
  };

  const setInitialState = () => {
    if (!gsap) return;

    if (cartDrawer) {
      gsap.set(cartDrawer, { x: "100%", display: "none" });
    }
    // Só esconde o backdrop se não houver modal ou menu drawer ativo
    const hasActiveModal = document.querySelector(".modal.active");
    const hasActiveMenuDrawer = window.menuDrawerIsOpen;
    if (backdrop && !hasActiveModal && !hasActiveMenuDrawer) {
      gsap.set(backdrop, { opacity: 0, pointerEvents: "none", display: "none" });
    }

    if (cartDrawerItems) {
      const items = cartDrawerItems.querySelectorAll(".cart-drawer-item");
      if (items && items.length > 0) {
        gsap.set(items, { opacity: 0, x: 20 });
      }
    }

    isOpen = false;
  };

  const preventPageScroll = (e) => {
    if (!cartDrawer || !e.target) return;
    if (cartDrawer.contains(e.target)) {
      e.stopPropagation();
      return;
    }
    e.preventDefault();
  };

  let drawerWheelHandler = null;

  const openCartDrawer = () => {
    if (isOpen || !cartDrawer || !backdrop || !gsap) return;

    // Fecha o menu-drawer se estiver aberto
    const menuDrawer = document.getElementById("menu-drawer");
    if (menuDrawer && window.menuDrawerIsOpen) {
      const menuCloseBtn = document.getElementById("btnCloseMenuDrawer");
      if (menuCloseBtn) {
        menuCloseBtn.click();
      }
    }

    isOpen = true;
    window.cartDrawerIsOpen = true;
    const timeline = gsap.timeline();

    if (cartDrawer) {
      timeline.set(cartDrawer, { display: "flex" });
    }
    if (backdrop) {
      timeline.set(backdrop, { display: "block" });
      timeline.to(backdrop, {
        opacity: 1,
        pointerEvents: "auto",
        duration: 0.3,
        ease: "power2.out",
      });
    }

    if (cartDrawer) {
      timeline.to(
        cartDrawer,
        {
          x: 0,
          duration: 0.4,
          ease: "power3.out",
        },
        "-=0.1"
      );
    }

    timeline.call(
      () => {
        animateCartItems("in");
      },
      null,
      "-=0.2"
    );

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    if (window.lenis) {
      window.lenis.options.wheelMultiplier = 0;
      window.lenis.options.touchMultiplier = 0;
    }

    cartDrawerItems.style.overflowY = "auto";
    cartDrawerItems.style.WebkitOverflowScrolling = "touch";

    drawerWheelHandler = (e) => {
      e.stopPropagation();
    };
    cartDrawerItems.addEventListener("wheel", drawerWheelHandler, {
      passive: true,
      capture: true,
    });
    cartDrawerItems.addEventListener("touchmove", drawerWheelHandler, {
      passive: true,
      capture: true,
    });

    document.addEventListener("wheel", preventPageScroll, {
      passive: false,
      capture: true,
    });
    document.addEventListener("touchmove", preventPageScroll, {
      passive: false,
      capture: true,
    });
  };

  const closeCartDrawer = () => {
    if (!isOpen || !gsap) return;

    isOpen = false;
    window.cartDrawerIsOpen = false;
    const timeline = gsap.timeline();

    timeline.call(() => {
      animateCartItems("out");
    });

    if (cartDrawer) {
      timeline.to(
        cartDrawer,
        {
          x: "100%",
          duration: 0.4,
          ease: "power3.in",
        },
        "-=0.1"
      );
    }

    if (backdrop) {
      timeline.to(
        backdrop,
        {
          opacity: 0,
          pointerEvents: "none",
          duration: 0.3,
          ease: "power2.in",
        },
        "-=0.2"
      );
      timeline.set(backdrop, { display: "none" });
    }
    if (cartDrawer) {
      timeline.set(cartDrawer, { display: "none" });
    }

    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    if (window.lenis) {
      window.lenis.options.wheelMultiplier = 1;
      window.lenis.options.touchMultiplier = 1;
    }

    if (drawerWheelHandler) {
      cartDrawerItems.removeEventListener("wheel", drawerWheelHandler, {
        capture: true,
      });
      cartDrawerItems.removeEventListener("touchmove", drawerWheelHandler, {
        capture: true,
      });
      drawerWheelHandler = null;
    }

    document.removeEventListener("wheel", preventPageScroll, { capture: true });
    document.removeEventListener("touchmove", preventPageScroll, {
      capture: true,
    });
  };

  btnOpenCart.addEventListener("click", openCartDrawer);

  if (btnCloseCart) {
    btnCloseCart.addEventListener("click", closeCartDrawer);
  }

  backdrop.addEventListener("click", closeCartDrawer);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen) {
      closeCartDrawer();
    }
  });

  setInitialState();

  // Expor função globalmente para uso em outros scripts
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.refreshCartDrawer = function () {
    // Função para recarregar o conteúdo do cart-drawer via AJAX
    const $ = window.jQuery || window.$;
    if (!$) return;

    $.ajax({
      type: "POST",
      url: window.wc_add_to_cart_params?.ajax_url || "/wp-admin/admin-ajax.php",
      data: {
        action: "refresh_cart_drawer",
      },
      dataType: "json",
      success: function (response) {
        if (response && response.success && response.data.html) {
          const drawerHTML = response.data.html;
          const $cartDrawer = $("#cart-drawer");
          const $itemsContainer = $cartDrawer.find("#cart-drawer-items");
          const $footerContainer = $cartDrawer.find(
            ".shrink-0.border-t-2.border-text-2\\/20.bg-neutral-50",
          );
          const $newDrawer = $(drawerHTML);

          // Atualiza os itens do carrinho
          $itemsContainer.html($newDrawer.find("#cart-drawer-items").html());

          // Atualiza o footer completo para refletir subtotal, total e bot�es
          if ($footerContainer.length) {
            $footerContainer.html(
              $newDrawer
                .find(".shrink-0.border-t-2.border-text-2\\/20.bg-neutral-50")
                .html(),
            );
          }

          // Atualiza o badge do carrinho no header
          const $badge = $("#cartBadge");
          const cartCount = response.data.cart_count || 0;
          if (cartCount > 0) {
            $badge.text(cartCount).removeClass("hidden");
          } else {
            $badge.addClass("hidden");
          }
        }
      },
    });
  };

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isOpen) {
        setInitialState();
      }
    }, 250);
  });
}

function initMenuDrawer() {
  const menuDrawer = document.getElementById("menu-drawer");
  const backdrop = document.getElementById("backdrop");
  const btnOpenMenu = document.getElementById("btnOpenMenuDrawer");
  const btnCloseMenu = document.getElementById("btnCloseMenuDrawer");
  const cartDrawer = document.getElementById("cart-drawer");

  if (!menuDrawer || !backdrop || !btnOpenMenu) return;

  let isOpen = false;

  const setInitialState = () => {
    if (!gsap) return;

    if (menuDrawer) {
      gsap.set(menuDrawer, { x: "-100%", display: "none" });
    }
    // Só esconde o backdrop se não houver modal ativo
    const hasActiveModal = document.querySelector(".modal.active");
    const hasActiveCartDrawer = window.cartDrawerIsOpen;
    if (backdrop && !hasActiveModal && !hasActiveCartDrawer) {
      gsap.set(backdrop, { opacity: 0, pointerEvents: "none", display: "none" });
    }
    isOpen = false;
    window.menuDrawerIsOpen = false;
  };

  const preventPageScroll = (e) => {
    if (!menuDrawer || !e.target) return;
    if (menuDrawer.contains(e.target)) {
      e.stopPropagation();
      return;
    }
    e.preventDefault();
  };

  const openMenuDrawer = () => {
    if (isOpen || !menuDrawer || !backdrop || !gsap) return;

    // Fecha o cart-drawer se estiver aberto
    if (cartDrawer && window.cartDrawerIsOpen) {
      const cartCloseBtn = document.getElementById("btnCloseCartDrawer");
      if (cartCloseBtn) {
        cartCloseBtn.click();
      }
    }

    isOpen = true;
    window.menuDrawerIsOpen = true;
    const timeline = gsap.timeline();

    if (menuDrawer) {
      timeline.set(menuDrawer, { display: "flex" });
    }
    if (backdrop) {
      timeline.set(backdrop, { display: "block" });
      timeline.to(backdrop, {
        opacity: 1,
        pointerEvents: "auto",
        duration: 0.3,
        ease: "power2.out",
      });
    }

    if (menuDrawer) {
      timeline.to(
        menuDrawer,
        {
          x: 0,
          duration: 0.4,
          ease: "power3.out",
        },
        "-=0.1"
      );
    }

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    if (window.lenis) {
      window.lenis.options.wheelMultiplier = 0;
      window.lenis.options.touchMultiplier = 0;
    }

    menuDrawer.style.overflowY = "auto";
    menuDrawer.style.WebkitOverflowScrolling = "touch";

    document.addEventListener("wheel", preventPageScroll, {
      passive: false,
      capture: true,
    });
    document.addEventListener("touchmove", preventPageScroll, {
      passive: false,
      capture: true,
    });
  };

  const closeMenuDrawer = () => {
    if (!isOpen || !gsap) return;

    isOpen = false;
    window.menuDrawerIsOpen = false;
    const timeline = gsap.timeline();

    if (menuDrawer) {
      timeline.to(menuDrawer, {
        x: "-100%",
        duration: 0.4,
        ease: "power3.in",
      });
    }

    if (backdrop) {
      timeline.to(
        backdrop,
        {
          opacity: 0,
          pointerEvents: "none",
          duration: 0.3,
          ease: "power2.in",
        },
        "-=0.2"
      );
      timeline.set(backdrop, { display: "none" });
    }
    if (menuDrawer) {
      timeline.set(menuDrawer, { display: "none" });
    }

    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    if (window.lenis) {
      window.lenis.options.wheelMultiplier = 1;
      window.lenis.options.touchMultiplier = 1;
    }

    document.removeEventListener("wheel", preventPageScroll, { capture: true });
    document.removeEventListener("touchmove", preventPageScroll, {
      capture: true,
    });
  };

  btnOpenMenu.addEventListener("click", openMenuDrawer);

  if (btnCloseMenu) {
    btnCloseMenu.addEventListener("click", closeMenuDrawer);
  }

  backdrop.addEventListener("click", closeMenuDrawer);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen) {
      closeMenuDrawer();
    }
  });

  setInitialState();

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isOpen) {
        setInitialState();
      }
    }, 250);
  });
}

function initHeaderSearch() {
  const btnOpenSearch = document.getElementById("btnOpenSearch");
  const headerSearch = document.getElementById("headerSearch");
  const headerNav = document.getElementById("headerNav");

  if (!btnOpenSearch || !headerSearch) return;

  let isOpen = false;

  const updatePosition = () => {
    if (!btnOpenSearch || !headerSearch) return;
    const rect = btnOpenSearch.getBoundingClientRect();

    // Calcula offset dinâmico baseado na largura da tela
    // Em telas menores, reduz o offset para evitar sobreposição
    const screenWidth = window.innerWidth;
    let offset = 20;

    if (screenWidth < 1699) {
      offset = 10;
    }
    if (screenWidth < 1280) {
      offset = 10;
    }
    if (screenWidth < 1024) {
      offset = 5;
    }
    if (screenWidth < 768) {
      offset = 0;
    }

    const right = window.innerWidth - rect.right - offset;
    const top = rect.top + rect.height / 2;

    Object.assign(headerSearch.style, {
      right: `${right}px`,
      top: `${top}px`,
      transform: "translateY(-50%)",
    });
  };

  const setInitialState = () => {
    if (!gsap || !headerSearch) return;
    
    updatePosition();
    gsap.set(headerSearch, {
      opacity: 0,
      width: "36px",
      scaleX: 1,
      display: "none",
    });
    const form = headerSearch.querySelector("form");
    if (form) {
      gsap.set(form, { overflow: "hidden" });
    }
    if (headerNav) {
      gsap.set(headerNav, { opacity: 1, x: 0 });
    }
    isOpen = false;
  };

  const openSearch = () => {
    if (isOpen || !headerSearch || !gsap) return;

    isOpen = true;
    const timeline = gsap.timeline();
    const form = headerSearch.querySelector("form");

    // Esconde o menu de navegação (desliza um pouco para a direita e fica invisível)
    if (headerNav) {
      timeline.to(headerNav, {
        opacity: 0,
        x: "30px",
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          if (headerNav) {
            headerNav.style.display = "none";
          }
        },
      });
    }

    // Atualiza posição antes de mostrar
    updatePosition();

    // Esconde o ícone do formulário
    const searchFormButton = headerSearch.querySelector("#searchFormButton");
    if (searchFormButton) {
      timeline.set(searchFormButton, { display: "none" });
    }

    // Mostra o campo de busca (expande horizontalmente a partir do botão)
    timeline.set(headerSearch, { display: "block" });
    if (form) {
      timeline.set(form, { overflow: "hidden" });
    }

    timeline.fromTo(
      headerSearch,
      { opacity: 0, width: "36px" },
      {
        opacity: 1,
        width: "300px",
        duration: 0.4,
        ease: "power3.out",
      },
      "-=0.1"
    );

    // Foca no input após a animação
    timeline.call(() => {
      const input = headerSearch.querySelector('input[type="text"]');
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
      if (form) {
        form.style.overflow = "visible";
      }
    });
  };

  const closeSearch = () => {
    if (!isOpen || !headerSearch || !gsap) return;

    isOpen = false;
    const timeline = gsap.timeline();
    const form = headerSearch.querySelector("form");

    if (form) {
      form.style.overflow = "hidden";
    }

    // Esconde o campo de busca (reduz horizontalmente até o tamanho do botão)
    timeline.to(headerSearch, {
      opacity: 0,
      width: "36px",
      duration: 0.4,
      ease: "power3.in",
      onComplete: () => {
        if (headerSearch) {
          headerSearch.style.display = "none";
          // Mostra o ícone do formulário novamente
          const searchFormButton =
            headerSearch.querySelector("#searchFormButton");
          if (searchFormButton) {
            searchFormButton.style.display = "flex";
          }
        }
      },
    });

    // Mostra o menu de navegação (desliza da direita para a posição original)
    if (headerNav) {
      timeline.set(headerNav, { display: "flex", x: "30px", opacity: 0 });
      timeline.to(
        headerNav,
        {
          opacity: 1,
          x: 0,
          duration: 0.5,
          ease: "power1.out",
        },
        "-=0.2"
      );
    }
  };

  const toggleSearch = () => {
    if (isOpen) {
      closeSearch();
    } else {
      openSearch();
    }
  };

  btnOpenSearch.addEventListener("click", toggleSearch);

  // Fecha ao pressionar ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen) {
      closeSearch();
    }
  });

  // Fecha ao clicar fora
  document.addEventListener("click", (e) => {
    if (
      isOpen &&
      !headerSearch.contains(e.target) &&
      !btnOpenSearch.contains(e.target)
    ) {
      closeSearch();
    }
  });

  setInitialState();

  // Atualiza posição no resize
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (isOpen) {
        updatePosition();
      } else {
        setInitialState();
      }
    }, 100);
  });

  // Atualiza posição no scroll (header é fixo, mas pode haver mudanças)
  window.addEventListener("scroll", () => {
    if (isOpen) {
      updatePosition();
    }
  });
}

/**
 * Animação do título da página de conta
 */
function initTitleAccountAnimation() {
  const titleElement = document.querySelector(".title-account-animation");
  
  if (!titleElement) return;

  const originalHTML = titleElement.innerHTML;
  titleElement.innerHTML = "";
  const lines = originalHTML.split(/<br\s*\/?>/i);
  
  lines.forEach((line, lineIndex) => {
    const lineWrapper = document.createElement("span");
    lineWrapper.style.display = "block";
    const words = line.trim().split(/\s+/);
    
    words.forEach((word, wordIndex) => {
      const wordSpan = document.createElement("span");
      wordSpan.style.display = "inline-block";
      wordSpan.style.whiteSpace = "nowrap";
      const letters = word.split("");
      
      letters.forEach((letter) => {
        const letterSpan = document.createElement("span");
        letterSpan.className = "letter-char";
        letterSpan.style.display = "inline-block";
        letterSpan.textContent = letter === " " ? "\u00A0" : letter;
        wordSpan.appendChild(letterSpan);
      });
      
      lineWrapper.appendChild(wordSpan);
      
      if (wordIndex < words.length - 1) {
        const spaceSpan = document.createElement("span");
        spaceSpan.textContent = "\u00A0";
        spaceSpan.style.display = "inline-block";
        lineWrapper.appendChild(spaceSpan);
      }
    });
    
    titleElement.appendChild(lineWrapper);
    
    if (lineIndex < lines.length - 1) {
      const br = document.createElement("br");
      titleElement.appendChild(br);
    }
  });

  const letters = titleElement.querySelectorAll(".letter-char");
  
  if (letters.length === 0 || !gsap) return;

  try {
    gsap.set(letters, {
      y: 20,
      opacity: 0,
    });

    gsap.to(letters, {
      y: 0,
      opacity: 1,
      duration: 0.4,
      ease: "power1.out",
      stagger: {
        amount: 0.6,
        from: "start",
      },
    });
  } catch (error) {
    console.warn("Erro ao animar título da conta:", error);
  }
}



